<template>
  <main class="news">
    <h1 class="news-title">{{ pr.title }}</h1>
    <div class="news-tab">
      <tabs v-model="active" @click="pageNum = 1">
        <tab v-for="(item, idx) in tabList" :key="idx" :title="item" />
      </tabs>
    </div>
    <div class="news-container">
      <NewsContent
        :list="filterList"
        :animation="false"
        :description="true"
        :image="true"
        :max-length="pageSize"
        :page-num="pageNum"
      />
      <Pagination v-if="filterList.length" :total="filterList.length" v-model:pageNum="pageNum" />
    </div>
  </main>
</template>

<script>
import { inject, ref } from 'vue';
import usePageResource from '@/composables/usePageResource';
import Tabs from '@/components/tabs/Index.vue';
import Tab from '@/components/tabs/Tab.vue';
import NewsContent from '@/components/news/NewsContent.vue';
import Pagination from '@/components/common/Pagination.vue';

export default {
  name: 'news-list',
  components: {
    Tabs,
    Tab,
    Pagination,
    NewsContent,
  },
  data() {
    return {
      pageSize: 10,
      pageNum: 1,
    };
  },
  setup() {
    const { pr } = usePageResource('news');
    const locale = inject('locale');
    const active = ref(0);
    return {
      pr,
      locale,
      active,
    };
  },
  computed: {
    tabList() {
      return Array.isArray(this.pr?.tabs) ? this.pr.tabs : [];
    },
    filterList() {
      if (!Array.isArray(this.pr?.list)) return [];
      return this.pr.list.filter((item) => !item.hidden && item.type === this.tabList[this.active]);
    },
  },
  beforeRouteEnter(to, from, next) {
    const { name } = from;
    if (name !== 'news-detail') {
      next();
      return;
    }
    next((vm) => {
      const storageNum = window.sessionStorage.getItem('pageNum');
      const currentActive = window.sessionStorage.getItem('currentActive');
      // eslint-disable-next-line no-param-reassign
      if (storageNum) vm.pageNum = Number(storageNum);
      // eslint-disable-next-line no-param-reassign
      if (currentActive) vm.active = Number(currentActive);
    });
  },
  beforeRouteLeave() {
    window.sessionStorage.setItem('pageNum', this.pageNum);
    window.sessionStorage.setItem('currentActive', this.active);
  },
};
</script>

<style lang="scss" scoped>
$height-header: 56px;
$breakpoints-md: 768px;
$height-top: 100px;
.news {
  padding: ($height-header + $height-top) 6.4vw 0;

  &-title {
    font-size: 30px;
    width: 100%;
    text-align: center;
    margin-bottom: 1.66em;
  }

  &-tab {
    max-width: 1200px;
    margin: 0 auto;
    margin-bottom: 44px;
  }

  @media screen and (max-width: $breakpoints-md) {
    padding: ($height-header * 2) 0 0;

    .news-title,
    .news-container {
      padding: 0 6.4vw;
    }

    .news-title {
      font-size: 22px;
    }
  }
}
</style>
